import React, { useContext, useEffect, useState } from "react";
import LiveVideo from "../LiveVideo";
import CourseOverView from "../CourseOverView";
import axios from "axios";
import Loading from "../../../utils/Loader/Loading";
import { MyContext } from "../../../pages/Funnel";

const MidMain = ({ id, state: details }) => {
  let [data, setState] = useState({});
  let [isLoading, setIsLoading] = useState(true);
  const { state } = useContext(MyContext);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    let fetchCards = async () => {
      try {
        let response = await axios.get(
          `https://vercel-deployment-w4ja.onrender.com/api/get_program/${id}`
        );
        setState(response.data.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCards();
  }, []);

  return (
    <div>
      {isLoading && (
        <div className="my-50 flex justify-center items-center h-screen">
          <Loading />
        </div>
      )}
      {!isLoading && !isError && data !== "Program not found" && (
        <>
          {" "}
          <LiveVideo youtube_link={data?.youtube_link} />
          <CourseOverView program_overview={data?.program_overview} />
        </>
      )}
      {isError && "Error Occurred"}
    </div>
  );
};

export default MidMain;
